const router = [
  {
    path: '/delivery/list',
    name: 'DeliveryList',
    component: () => import('@/views/delivery/DeliveryList.vue'),
    meta: {
      title: '发货确认',
      checkToken: true
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/delivery/Search.vue'),
    meta: {
      title: '高级筛选',
      checkToken: true
    }
  }
];
export default router;
